/** @format */

import React, { useContext, useEffect, useState } from "react";
import { itemServices } from "../../Services/item.service";
import CardWrap from "../Common/CardWrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import ItemNormative from "../Normative/ItemNormative";
import NormativeList from "../Normative/NormativeList";
import { Tabs, Tab } from "react-bootstrap";

const ItemDetails = ({ match }) => {
  const history = useHistory();
  const [key, setKey] = useState("normatives");
  const { t: translator } = useTranslation();
  const [item, setItem] = useState(null);

  useEffect(() => {
    itemServices
      .getById(match.params.priceListId, match.params.itemId)
      .then((res) => {
        setItem(res.data);
      })
      .catch((err) => console.log(err.response));
  }, []);

  const updateItem = () => {
    history.push(`/edit-item/${match.params.priceListId}/${item.itemId}`);
  };

  const handleCancle = () => {
    history.goBack();
  };

  return (
    <CardWrap subtitle={translator("Breadcrumb-ItemDetails")}>
      {item !== null && (
        <div className="row pl-0">
          <div className="col-lg-3">
            <div className="custom-card m-2">
              <div className="custom-card-header">
                <h3>
                  {item.name}
                  <span className="button-edit">
                    {" "}
                    <span
                      onClick={updateItem}
                      title={translator("PosDetail-EditIcon-Title")}
                      className="icon icon-edit"
                    ></span>
                  </span>
                </h3>
                <span className="custom-card-subtitle">
                  <strong>{translator("Price")}:</strong>{" "}
                  {item.price !== null ? `${item.price} EUR` : "0 EUR"}
                </span>
                <hr />
              </div>
              <div className="custom-card-body">
                <p>
                  <span>
                    <strong>{translator("EditItem-RawMaterial")}:</strong>{" "}
                    {item.isRawMaterial
                      ? translator("POS-POSDetails-FiscalObligation-Yes")
                      : translator("POS-POSDetails-FiscalObligation-No")}
                  </span>
                  <br />
                  <span>
                    <strong>{translator("Description")}:</strong>
                    {" " + item.description}
                  </span>
                  <br />
                  <span>
                    <strong>{translator("EditItem-ItemGroup")}:</strong>{" "}
                    {item.itemGroupName}
                  </span>
                  <br />
                  <span>
                    <strong>{translator("EditItem-UnitOfMeasure")}:</strong>
                    {" " + item.unitOfMeasureName}
                  </span>
                </p>
                <hr />
                <p>
                  <span>
                    <strong>{translator("EditItem-TaxRate")}:</strong>{" "}
                    {item.taxRateName}
                  </span>
                  <br />
                  <span>
                    <strong>{translator("EditItem-ConsummationTax")}</strong>{" "}
                    {item.pp === null ? "0%" : `${item.pp} %`}
                  </span>
                  <br />
                  <span>
                    <strong>{translator("EditItem-Refunds")}:</strong>{" "}
                    {item.pn === null ? "0 EUR" : `${item.pn} EUR`}
                  </span>
                </p>
              </div>
              <div className="custom-card-footer"></div>
            </div>
          </div>
          <div className="col-lg-9 border-left">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => {
                setKey(k);
              }}
            >
              <Tab
                style={{ marginLeft: "-18px" }}
                eventKey="normatives"
                title={
                  item.isRawMaterial
                    ? translator("Proizvodi")
                    : translator("Normativi")
                }
                tabClassName="mob-tabs"
              >
                {item.isRawMaterial ? (
                  <NormativeList productGuid={match.params.itemId} />
                ) : (
                  <ItemNormative
                    productGuid={match.params.itemId}
                    tenantId={item.tenantId}
                  />
                )}
              </Tab>
            </Tabs>
          </div>
        </div>
      )}
      <div
        className="container-fluid"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <button className="btn btn-outline-secondary" onClick={handleCancle}>
          {translator("User-UserDetail-BtnBack")}
        </button>
      </div>
    </CardWrap>
  );
};

export default ItemDetails;
